package top.wcpe.allincore.layout.engine

/**
 * 主轴对齐方式（含 SPACE_*）。
 *
 * 注意：Flex 主轴语义里没有 stretch；早期 STRETCH 在 Taffy 端被映射成 AlignContent.STRETCH（实际是
 * 交叉轴语义），属于误导项，已删除。要让子项在交叉轴拉伸请用 [Align.STRETCH]。
 */
enum class Justify {
    START,
    CENTER,
    END,
    SPACE_BETWEEN,
    SPACE_AROUND,

    /** 子项之间以及首尾两侧均分主轴剩余空间。映射到 Taffy `AlignContent.SPACE_EVENLY`。 */
    SPACE_EVENLY
}
